import {Link} from 'react-router-dom';

import {QuestionAutoMatches} from '~/features/AiSupport/QuestionAutoMatches';

export const QuestionAutoMatchesScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <div className="text-sm breadcrumbs p-4">
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/ai-support/question-sample-sets">
              AI Support
            </Link>
          </li>
          <li>Question Auto Matches</li>
        </ul>
      </div>
      <QuestionAutoMatches />
    </div>
  );
};
